import React, { useState } from "react";

const Support = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [errors, setErrors] = useState({});

  const handleFileChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  return (
    <div className="min-h-screen">
      <div
        className="w-full flex items-center"
        style={{
          background:
            "linear-gradient(to bottom, rgba(225, 225, 225, 1) 0%, rgba(225, 225, 225, 0) 100%)",
          padding: "35px 21px 26px",
        }}
      >
        <button
          onClick={onBack}
          className=" absolute top-[34px] bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <h1 className="text-[20px] leading-[20px] font-normal font-young-serif text-center mx-auto">
          Support
        </h1>
      </div>

      <div className="px-6">
        <div className="mx-1 border-t border-[#EEEEEE] pb-3" />
        <h2 className="text-[16px] leading-[22px] font-normal text-[#1E0A1E] font-young-serif mb-6">
          Submit a request
        </h2>

        <div className="mb-2">
          <label className="block text-[14px] text-[#1E0A1E] font-medium mb-2 font-space-grotesk">
            Email
            <span className="text-red-500 font-normal font-space-grotesk">
              *
            </span>
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`w-full border rounded-full p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 ${
              errors.email ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.email && (
            <p className="text-sm text-red-500 mt-2">{errors.email}</p>
          )}
        </div>

        {/* Subject */}
        <div className="mb-6">
          <label className="block text-[14px] text-[#1E0A1E] font-medium mb-2 font-space-grotesk">
            Subject<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className={`w-full border rounded-full p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 ${
              errors.subject ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.subject && (
            <p className="text-sm text-red-500 mt-2">{errors.subject}</p>
          )}
        </div>

        <div className="mb-6">
          <label className="block text-[14px] text-[#1E0A1E] font-medium mb-2 font-space-grotesk">
            Description<span className="text-red-500">*</span>
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            className={`w-full border rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-purple-500 ${
              errors.description ? "border-red-500" : "border-gray-300"
            }`}
          ></textarea>
          {errors.description && (
            <p className="text-sm text-red-500 mt-2">{errors.description}</p>
          )}
        </div>

        <div className="mb-6">
          <label className="block text-[14px] text-[#1E0A1E] font-medium mb-2 font-space-grotesk">
            Attachments
          </label>
          <label
            htmlFor="file"
            className="block w-full border text-[16px] text-medium border-gray-300 rounded-full p-2 text-center text-[#B08CFF] cursor-pointer font-space-grotesk"
          >
            Add file
          </label>
          <input
            type="file"
            id="file"
            onChange={handleFileChange}
            className="hidden"
          />
          {attachment && (
            <div className="flex items-center gap-2 mt-2 w-full">
              <div className="flex items-center gap-2">
                <img src="/images/clip.png" alt="clip" className="w-3 h-3" />
                <p className="text-[14px] text-[#929292] font-space-grotesk font-medium">
                  {attachment.name}
                </p>
              </div>
              <button
                onClick={() => setAttachment(null)}
                className="text-[#929292] hover:text-[#1E0A1E]"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>

        <div className="flex justify-start mt-6 mb-8">
          <button className="bg-[#1E0A1E] text-[#EEEEEE] font-space-grotesk text-[16px] font-medium py-2 px-6 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
            Submit
          </button>
        </div>
      </div>

      <div className="fixed bottom-6 right-6">
        <button>
          <svg
            width="65"
            height="65"
            viewBox="0 0 65 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_402_9413)">
              <circle cx="30.104" cy="30.105" r="29.896" fill="#B08CFF" />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M29.5872 12.5837C19.1181 12.5837 10.1548 19.952 10.1548 29.5871C10.1548 34.5045 12.5316 38.8789 16.225 41.9384C16.1878 43.5042 15.7289 44.9606 14.958 46.2041C14.6222 46.7459 14.5939 47.4239 14.8837 47.9918C15.1734 48.5597 15.7389 48.9348 16.3747 48.9809C16.7274 49.0065 17.0833 49.0195 17.4419 49.0195C20.6087 49.0195 23.5432 48.0076 25.9343 46.2908C27.1188 46.4877 28.3401 46.5904 29.5872 46.5904C40.0562 46.5904 49.0196 39.2222 49.0196 29.5871C49.0196 19.952 40.0562 12.5837 29.5872 12.5837ZM29.5872 32.0161C30.9287 32.0161 32.0162 30.9286 32.0162 29.5871C32.0162 28.2456 30.9287 27.158 29.5872 27.158C28.2457 27.158 27.1581 28.2456 27.1581 29.5871C27.1581 30.9286 28.2457 32.0161 29.5872 32.0161ZM24.7291 29.5871C24.7291 30.9286 23.6416 32.0161 22.3 32.0161C20.9585 32.0161 19.871 30.9286 19.871 29.5871C19.871 28.2456 20.9585 27.158 22.3 27.158C23.6416 27.158 24.7291 28.2456 24.7291 29.5871ZM36.8743 32.0161C38.2159 32.0161 39.3034 30.9286 39.3034 29.5871C39.3034 28.2456 38.2159 27.158 36.8743 27.158C35.5328 27.158 34.4453 28.2456 34.4453 29.5871C34.4453 30.9286 35.5328 32.0161 36.8743 32.0161Z"
              fill="#1E0A1E"
            />
            <defs>
              <filter
                id="filter0_d_402_9413"
                x="0.208008"
                y="0.208984"
                width="64.792"
                height="64.792"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="5" dy="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_402_9413"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_402_9413"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Support;
